import { CheckCircle2 } from "lucide-react";

const POINTS = [
  "Tüm kombi markalarında uzman kadro (Vaillant, Baymak, Demirdöküm, Beko, Arçelik, Buderus, Protherm)",
  "Orijinal yedek parça, faturalı ve garantili işçilik",
  "Acil durumlarda Diyarbakır içinde aynı gün müdahale",
  "Bakım sözleşmesi ile yıllık periyodik kontrol",
  "Doğalgaz tesisat projelerinde yetkili montaj",
  "Şeffaf fiyatlandırma — iş öncesi net teklif",
];

export default function About() {
  return (
    <section id="about" className="py-20 lg:py-32 bg-zinc-50" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#1D4ED8] mb-4" data-testid="about-overline">
            / Hakkımızda
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-zinc-950 leading-[1.05]" data-testid="about-title">
            Diyarbakır'da <br />
            <span className="italic font-light">yıllardır</span> güvenin adı.
          </h2>
          <p className="mt-6 text-base lg:text-lg text-zinc-600 leading-relaxed">
            Kayapınar Peyas Mahallesi'ndeki dükkanımızdan başlayarak tüm Diyarbakır'a
            kombi, şofben, doğalgaz ve sıhhi tesisat hizmeti veriyoruz. Zor günlerinizde
            hızlı müdahale, kalıcı çözüm ve dürüst fiyat anlayışımızla yanınızdayız.
          </p>
          <div className="mt-8 flex items-center gap-6 pt-6 border-t border-zinc-200">
            <div>
              <div className="text-4xl font-black text-zinc-950">15+</div>
              <div className="text-xs uppercase tracking-widest text-zinc-500 font-bold">yıl deneyim</div>
            </div>
            <div className="h-12 w-px bg-zinc-300" />
            <div>
              <div className="text-4xl font-black text-zinc-950">5.000+</div>
              <div className="text-xs uppercase tracking-widest text-zinc-500 font-bold">servis</div>
            </div>
            <div className="h-12 w-px bg-zinc-300" />
            <div>
              <div className="text-4xl font-black text-zinc-950">7/24</div>
              <div className="text-xs uppercase tracking-widest text-zinc-500 font-bold">hizmet</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <ul className="space-y-5">
            {POINTS.map((p, i) => (
              <li key={i} className="flex items-start gap-4 p-4 bg-white border border-zinc-200 rounded-sm hover:-translate-y-0.5 transition-transform" data-testid={`about-point-${i}`}>
                <CheckCircle2 className="w-6 h-6 text-[#FF4500] shrink-0 mt-0.5" />
                <span className="text-sm lg:text-base text-zinc-800 font-medium leading-relaxed">{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
